import React, { useMemo } from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../redux/store';
import {
    FileUploadState,
    uploadedFilesSelector,
} from '../../../../redux/import/sliceImportFileUpload';
import { useTranslation } from 'react-i18next';
import Documents from '../_parts/Documents';
import LabelAndValue from '../_parts/LabelAndValue';
import i18n from '../../../../localization/i18n';
import { mdiAlertCircle, mdiCheckCircle } from '@mdi/js';
import Icon from '@mdi/react';
import AppTooltip from '../../AppTooltip/AppTooltip';
import { vars } from '../../../../Theme';

const getStateIcon = (uploadState: FileUploadState) => {
    if (uploadState.isLoading) {
        return <CircularProgress size='24px' sx={{ color: vars.font }} />;
    }

    if (uploadState.isUploaded) {
        return <Icon path={mdiCheckCircle} size={1} color={vars.brandGreen} />;
    }

    return (
        <AppTooltip title={uploadState.reason}>
            <Icon path={mdiAlertCircle} size={1} color={vars.errorRed} />
        </AppTooltip>
    );
};

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'uploadDialog' });

    const files = useSelector((_store: IAppReduxStore) => _store.projectFileUpload.fileModels);
    const uploadedFiles = useSelector(uploadedFilesSelector);
    const importDocTypes = useSelector((_store: IAppReduxStore) => _store.importDocTypes.data);
    const selectedDocType = useSelector(
        (_store: IAppReduxStore) => _store.importDialog.selectedDocType,
    );

    const docs = useMemo(
        () =>
            files.map(x => ({
                universalId: x.id,
                title: x.fileName,
                statusIcon: getStateIcon(x.uploadState),
            })),
        [files, uploadedFiles],
    );

    return (
        <>
            <Stack sx={{ m: 0, marginTop: '16px' }}>
                <Documents
                    title={t('labelCompleteDocuments', {
                        count: uploadedFiles.length,
                        total: files.length,
                    })}
                    documents={docs}
                    defaultExpanded={true}
                />
            </Stack>
            <LabelAndValue
                label={t('documentType')}
                value={
                    importDocTypes.find(x => x.name === selectedDocType?.name)?.translations?.[
                        i18n.language
                    ]
                }
                boxSx={{ marginTop: '8px' }}
                separator='colon'
            />
        </>
    );
};
